<form [formGroup]="dateForm">
    <div class="form-action d-flex">
        <div class="form-action_radio">
            <mat-radio-group formControlName="selectDate" class="custom-mat-radio">
                <mat-radio-button [value]="'weekly'">Weekly</mat-radio-button>
                <mat-radio-button [value]="'monthly'">Monthly </mat-radio-button>
                <mat-radio-button [value]="'quarterly'">Quarterly </mat-radio-button>
            </mat-radio-group>
        </div>

        <div class="form-action_check">
            <div *ngIf="dateForm.get('selectDate').value == 'weekly'">
                <div class="mb-2" *ngFor="let selectedDay of day">
                    <mat-checkbox class="mat-checkbox-sm" (change)="selectDay($event,selectedDay)"
                        [checked]="selectedDay.checked">{{selectedDay.name}}</mat-checkbox>
                </div>
            </div>

            <div *ngIf="dateForm.get('selectDate').value == 'monthly'">
                <div class="mb-2" *ngFor="let selectedMonth of months; let i = index">
                        <mat-checkbox class="mat-checkbox-sm" (change)="selectMonth($event,selectedMonth)"
                            [checked]="selectedMonth.checked">{{selectedMonth.name}}</mat-checkbox>
                </div>
            </div>

            <div *ngIf="dateForm.get('selectDate').value == 'quarterly'">
                <div class="mb-2" *ngFor="let selectedQuarterly of quartely">
                    <mat-checkbox class="mat-checkbox-sm" (change)="selectQuartely($event,selectedQuarterly)"
                        [checked]="selectedQuarterly.checked">
                        {{selectedQuarterly.months}}</mat-checkbox>
                </div>
            </div>
        </div>
    </div>
    <div class="form-footer d-flex justify-content-end p-3">
        <app-button [buttonSize]="'action'" [buttonStyle]="'primary'" (click)="reset()">Reset</app-button>
        <app-button [buttonSize]="'action'" [buttonStyle]="'primary'" [spin]="spin" [isDisabled] ="isDisable" (click)=save()>Save</app-button>
    </div>
</form>